var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTarget = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.8 7.796a9.76 9.76 0 1 1-2.456-3.202l2.125-2.127a.75.75 0 1 1 1.062 1.062l-9 9a.75.75 0 0 1-1.062-1.062l2.6-2.598a3.75 3.75 0 1 0 1.674 2.914.751.751 0 0 1 1.5-.084 5.25 5.25 0 1 1-2.098-3.905l2.133-2.132a8.239 8.239 0 1 0 2.169 2.781.75.75 0 1 1 1.353-.647"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.447 8.443a8.239 8.239 0 1 1-2.169-2.781l-2.133 2.132a5.25 5.25 0 1 0 2.098 3.905.75.75 0 1 0-1.5.084 3.75 3.75 0 1 1-1.675-2.914l-2.599 2.598a.75.75 0 0 0 1.062 1.062l9-9a.75.75 0 1 0-1.062-1.061l-2.125 2.126A9.76 9.76 0 1 0 20.8 7.796a.75.75 0 1 0-1.353.647m1.444-.69a9.859 9.859 0 1 1-2.552-3.295l2.06-2.061A.85.85 0 1 1 21.6 3.599l-9 9a.85.85 0 0 1-1.202-1.202l2.51-2.51a3.65 3.65 0 1 0 1.735 2.902.851.851 0 0 1 1.7-.096 5.35 5.35 0 1 1-2.209-4.03l1.994-1.994a8.139 8.139 0 1 0 2.227 2.817.85.85 0 0 1 1.534-.733",
  clipRule: "evenodd"
})));
export default SvgTarget;